/*
 * @Author: kennthKun c_kunx@163.com
 * @Date: 2022-10-31 14:04:02
 * @LastEditors: kennthKun c_kunx@163.com
 * @LastEditTime: 2022-11-04 10:54:22
 * @FilePath: /kx_component/src/components/input/default.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { v4 as uuidv4 } from 'uuid';

export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: "text",
    FormItemProps: {
      label: '文本',
      name: uuid,
    }
  }
}
